import { cronosClient } from "@/config/client"

export type CourseStatus = "reschedule" | "at_risk" | "on_track"

export interface Unit {
  id: string
  name: string
  progress: number
}

export interface Module {
  id: string
  name: string
  progress: number
  units: Unit[]
}

export interface Milestone {
  title: string
  dateTime: Date
  modules: string[] | null
}

export interface ApprovedWeeklyObjective {
  id: string
  name: string
}

interface GetMySituationResponse {
  description: {
    courseProgress: number
    courseStatus: CourseStatus
    weeklyCourseProgress: number
    approvedActivitiesProgress: number
    masteredUnits: number
    modules: Module[]
    currentWeekNumber: number
    approvedActivitiesDiff?: number
    masteredUnitsDiff?: number
    weeklyCourseProgressDiff?: number
    milestones: Milestone[]
    approvedWeeklyObjectives: ApprovedWeeklyObjective[]
  }
}

export async function get(courseId: string) {
  return cronosClient.get<GetMySituationResponse>(`/v1/courses/${courseId}/situation`)
}
